import { useTranslation } from 'react-i18next';
import { EApiType, EDataTableType, EModuleType } from '../../../data/Constants';
import { MaintenanceTable } from '../../Layouts/DataTable';
import { getQueue } from '../../../store/states/QueueSlice';
import { useApiError } from '../../../hooks';
import { formatLogContent } from '../../Helper/DataTableHelper';
import type { IManagementProps } from '../../../../types';

export const QueueManagement = (props: IManagementProps) => {
  const { t } = useTranslation();
  const errorElement = useApiError(EApiType.QueueKey);

  if (errorElement) return errorElement;

  return (
    <>
      <h3 className="mainHeader"> {t('labels.queueManagement')}</h3>
      <MaintenanceTable
        token={props.token}
        type={EDataTableType.Queue}
        getDataList={getQueue}
        moduleType={EModuleType.Notifications}
        getLogContent={formatLogContent}
      />
    </>
  );
};
